import clients from 'redux/clients'
const {
  cloudloyalty: { client }
} = clients

export const listValuesRecharge = (
  operatorKey,
  areaCode,
  successCallback,
  errorCallback
) => {
  client
    .get(`/v1/mobileRecharges/mobileoperator/${operatorKey}/areacode/${areaCode}/rechargeValue`)
    .then(response => successCallback(response.data))
    .catch(error => {
      if (errorCallback) errorCallback(error.response && error.response.data)
    })
}

export default { listValuesRecharge }



// WEBPACK FOOTER //
// ./src/features/Services/RechargePhone/FormStep/ValueRechargeClient.js